import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { ActionIconButton } from "../../../components/datatable/DataGridActions";

let columnsData = [
  {
    field: "name",
    headerName: "Kid Name",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "extra_curriculum_name",
    headerName: "Extra Curriculum",
    flex: 1,
    minWidth: 140,
  },

  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    minWidth: 100,
  },
];

let actionHeader = (handleDelete, setOpen, setSelectedRow) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      maxWidth: 120,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Edit"
              onClick={() => {
                setOpen(true);
                setSelectedRow(params.row);
              }}
            >
              <EditRoundedIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Delete"
              onClick={() => handleDelete(params.row.id)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
